import React, { useEffect, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";

/**
 * Filters the full list from `searchItems` and writes results via `setSearchItems`.
 * Parents must pass the authoritative full list as `searchItems` and a separate filtered state setter
 * (see ExistingWorkflowVariables). Do not pass the same state for both source and destination.
 */
const filterItems = (items, query) => {
  const source = items ?? [];
  const q = (query ?? "").trim().toLowerCase();
  if (!q) {
    return source;
  }
  return source.filter(
    (variable) =>
      variable?.name?.toLowerCase().includes(q) ||
      variable?.variableName?.toLowerCase().includes(q) ||
      variable?.label?.toLowerCase().includes(q)
  );
};

const SearchVariables = ({ searchItems, setSearchItems }) => {
  const [searchVariables, setSearchVariables] = useState("");

  useEffect(() => {
    setSearchItems(filterItems(searchItems, searchVariables));
  }, [searchItems, searchVariables, setSearchItems]);

  const handleSearchVariables = (e) => {
    setSearchVariables(e.target.value);
  };

  return <Input type='text' value={searchVariables} onChange={handleSearchVariables} placeholder='Search...' />;
};

export default SearchVariables;
